import { Pipe, PipeTransform } from '@angular/core'
import { keyBy } from 'lodash'
import { availableContractEventTypes, ContractSignStatus } from '../store'

@Pipe({
  name: 'signStatus',
  standalone: false,
})
export class SignStatusPipe implements PipeTransform {
  cfgByStatus = keyBy(availableContractEventTypes, 'id')

  transform(value: ContractSignStatus | string) {
    return this.cfgByStatus[value]
  }
}
